import { render, staticRenderFns } from "./SignUpForm.vue?vue&type=template&id=2072062d&scoped=true"
import script from "./SignUpForm.vue?vue&type=script&lang=ts"
export * from "./SignUpForm.vue?vue&type=script&lang=ts"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=2072062d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072062d",
  null
  
)

export default component.exports